import { isHmBrand } from "@pb/utils/brandConfig";
const trackingConstants = {
    TRACKING_NIB_COMPLETE_SUCCESS: Object.assign({}, (isHmBrand && { event_id: 'complete' })),
    TRACKING_NIB_SHOW_BECOME_MEMBER: {
        event_id: 'pop-up - sign-up/sign-in',
    },
    TRACKING_APP_STORE_CLICK: {
        event_category: 'Nib download app interactions',
        event_type: 'NIB App Store Click',
        event_id: 'Nib download app',
    },
};
var EventType;
(function (EventType) {
    EventType["NIB_COMPLETE_SUCCESS"] = "NIB_COMPLETE";
    EventType["NIB_SHOW_BECOME_MEMBER"] = "NIB_INITIATE_BECOME_MEMBER";
    EventType["NIB_INITIATE"] = "NIB_INITIATE";
})(EventType || (EventType = {}));
export { trackingConstants, EventType };
//# sourceMappingURL=trackingConstants.js.map